import { gql } from '@apollo/client';

/** Update a single email template by type. */
export const updateEmailTemplate = gql`mutation updateEmailTemplate($type: String, $subject: String, $previewText: String, $bodyHtml: String) {
  updateEmailTemplate(type: $type, subject: $subject, previewText: $previewText, bodyHtml: $bodyHtml) {
    status
    errorMessage
  }
}
`;
